import { palette } from '@livable/saas-react-components';
const MuiDivider = {
  styleOverrides: {
    root: {
      borderColor: palette.shades[300],
      margin: '8px 0 !important'
    }
  }
};
export default MuiDivider;